export enum StudioType {
  CHAT_AI = 'chat-ai',
  VOICE_AI = 'voice-ai',
  TICKET_AI = 'ticket-ai',
  EMAIL_AI = 'email-ai',
}

export const STUDIO_TYPE_LABELS: Record<StudioType, string> = {
  [StudioType.CHAT_AI]: 'Chat AI Studio',
  [StudioType.VOICE_AI]: 'Voice AI Studio',
  [StudioType.TICKET_AI]: 'Ticket AI Studio',
  [StudioType.EMAIL_AI]: 'Email AI Studio',
};

/**
 * The studios whose Train A.I. has the review flows.
 *
 * Shared rather than per-app because both sides gate on it and must not drift:
 * the frontend uses it for every in-app link into Train A.I. and for the template
 * responses route, and the backend uses it to pick the Train A.I. reminder
 * email's recipients. If the two disagree, that email points a studio at review
 * work it cannot do. The page itself and its sidebar entry use
 * TRAIN_AI_PAGE_STUDIO_TYPES, which also admits the read-only Voice A.I. studio.
 */
export const TRAIN_AI_STUDIO_TYPES = [StudioType.CHAT_AI, StudioType.TICKET_AI];

/**
 * The studios whose company can open the Train A.I. page itself. Voice A.I. gets
 * a read-only call list there, so it is on the page and the sidebar but not in
 * TRAIN_AI_STUDIO_TYPES: it receives no reminder email and is offered no link
 * into the review flows.
 */
export const TRAIN_AI_PAGE_STUDIO_TYPES = [
  ...TRAIN_AI_STUDIO_TYPES,
  StudioType.VOICE_AI,
];
